import informacaoNaoEncontradaImgPT from "../../assets/imagens/informacao-nao-encontradaPTBR.png";
import informacaoNaoEncontradaImgEN from "../../assets/imagens/informacao-nao-encontradaEN.png";

const InformacaoNaoEncontrada = () => {
  var lng = localStorage.getItem("i18nextLng");
  return (
    <div className="w-full mt-10 flex justify-center">
      <img
        className="max-w-[60%]"
        alt="Informação não encontrada"
        src={lng == "pt-BR" ? informacaoNaoEncontradaImgPT : informacaoNaoEncontradaImgEN}
      />
    </div>
  );
};

export default InformacaoNaoEncontrada;
